import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-summary.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.summary',
    description:
      'Total and unassigned requirement counts, click a row to filter the table below',
    name: 'Requirements Dashboard - Summary',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
